import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import { FeedActivityFragment } from '@spotify/confidence-graphql';

export interface FeedItemOptions {
  activity: FeedActivityFragment;
}

export interface FeedItemExtensionOptions
  extends ItemRenderExtensionOptions<FeedItemOptions> {}

export const FeedItemExtensions = createItemRenderExtensions({
  id: 'feed-item',
});

/**
 * Hook to retrieve all registered feed item extensions.
 *
 * @returns a list of feed item extensions
 */
export const useFeedItemExtensions = () => {
  return useItemRenderExtensions<FeedItemExtensionOptions>(FeedItemExtensions);
};

/**
 * Create a feed item extension renderer.
 *
 * @param options - options for the extension
 * @param options.predicate - predicate to determine if the extension should be
 *   used for the given activity
 * @param options.render - function to render the activity
 * @returns a Backstage extension
 */
export const createFeedItemExtension = (options: FeedItemExtensionOptions) => {
  return createItemRenderExtension<FeedItemExtensionOptions>(options);
};
